export default "__VITE_ASSET__BaThGhAE__"